<div *ngIf="!isProduction(mode)" class="environment-indicator">{{mode}}</div>
